import {Fragment, useEffect, useState} from 'react';

import {useToolbar} from '../../../shared/hooks/Toolbar';
import {useDataTable} from '../../../shared/hooks/DataTable';
import {useDialogCrup} from '../../../shared/hooks/DialogCrup';
import {TenantSettingService as Service} from '../tham-so-he-thong/TenantSettingService';
import {Button} from 'primereact/button';
import {useCellEditing} from '../../../shared/hooks/CellEditing';
import {ConfirmDialogService} from '../../../AppConfirmDialog';
import {allOperations} from '../../../shared/format';
import {ConfigService} from '../../../service/ConfigService';
import {ToastService} from '../../../AppToast';

const minuteNextStepOptions = [
  {value: 10, label: "10 phút"},
  {value: 15, label: "15 phút"},
  {value: 20, label: "20 phút"},
  {value: 25, label: "25 phút"},
  {value: 30, label: "30 phút"},
  {value: 45, label: "45 phút"},
];

const hours = [...Array(24).keys() as any].map(k => {
  return {value: k, label: `${k}h`}
})

const typeJobs = [
  {value: "sync_invoice", label: "Tạo hóa đơn từ danh sách giao dịch xăng dầu"},
  // {value: "sign_invoice", label: "Tự động Ký hóa đơn xăng dầu"},
];

export const List = () => {

  const header = 'cấu hình tạo hóa đơn xăng dầu từ bảng log';
  const dataKey = 'id';

  const [columns, setColumns] = useState([]);
  const [conditions, setConditions] = useState([]);

  useEffect(() => {
    ConfigService.get('petrolimex').then(data => {
      if (data?.items?.length) {
        setColumns(data.items.map(it => {
          return {value: it.field, label: it.header};
        }));
      }
    });
  }, []);

  const {render: renderDataTable, refreshLazyData, reloadLazyData, selectedItems} = useDataTable({
    header,
    dataKey,
    columns: [
      {field: 'minuteNextStep', header: 'Thời gian đồng bộ lại hóa đơn', matchMode: 'contains', width: 220},
      {field: 'condition', header: 'Điều kiện', minWidth: 400, matchMode: 'contains'},
      {field: 'typeJob', header: 'Loại đồng bộ', width: 180, matchMode: 'contains'},
      {field: 'startHour', header: 'Giờ bắt đầu', width: 180, matchMode: 'contains'},
      {field: 'endtHour', header: 'Giờ kết thúc', width: 180, matchMode: 'contains'},
      {field: 'isUse', header: 'Sử dụng', matchMode: 'equals', filterType: 'boolean', width: 160, dataType: 'checkbox'}
    ],
    actionColumnWidth: 0,
    getList: (params) => {
      return Service.getTenantJob(params);
    }
  });

  const addCondition = () => {
    setConditions(prevState => {
      prevState.push({
        _id: `${prevState.length}_${Date.now()}`
      });
      return [...prevState];
    });
  };

  const removeCondition = rowData => {
    ConfirmDialogService.confirmDelete(() => {
      setConditions(prevState => {
        return [...prevState.filter(it => it._id !== rowData._id)];
      });
    });
  };

  const {render: renderEditing} = useCellEditing({
    dataKey: 'id',
    columns: [
      {field: 'propertyName', header: 'Tên trường', editable: true, dataType: 'dropdown', inputProps: {options: columns}, style: {minWidth: '160px'}},
      {field: 'operation', header: 'Điều kiện', editable: true, dataType: 'dropdown', inputProps: {options: allOperations}, style: {minWidth: '100px', maxWidth: '100px'}},
      {field: 'value', header: 'Giá trị', editable: true, style: {minWidth: '170px'}},
      {
        field: 'remove', header: '', dataType: 'custom', customCell(rowData: any): any {
          return <Button icon="pi pi-trash" onClick={() => removeCondition(rowData)} className="p-button-rounded p-button-outlined p-button-danger"/>
        }, style: {minWidth: '40px', maxWidth: '40px'}, className: 'text-center'
      }
    ],
    items: conditions,
    onCellChange: (rowData, column, newValue) => {
      setConditions(prevState => {
        prevState?.forEach(it => {
          if (it._id === rowData._id) {
            it[column.field] = newValue;
          }
        });
        return [...prevState];
      });
    }
  });

  const {render: renderDialogCrup, create, update, clone} = useDialogCrup({
    header,
    dataKey,
    width: '70rem',
    fields: [
      {field: 'minuteNextStep', header: 'Thời gian đồng bộ lại hóa đơn', required: true, type: 'Dropdown', DropdownProps: {options: minuteNextStepOptions, filter: true}, className: 'md:col-6'},
      {field: 'isUse', type: 'Checkbox', header: 'Sử dụng', className: 'md:col-6 pt-6 pl-4 mb-0'},
      {field: 'startHour', header: 'Bắt đầu quét từ', required: true, type: 'Dropdown', DropdownProps: {options: hours, filter: true}, className: 'md:col-6'},
      {field: 'endtHour', header: 'Kết thúc quét khi hết', required: true, type: 'Dropdown', DropdownProps: {options: hours, filter: true}, className: 'md:col-6'},
      {type: 'custom', body: <hr className="mt-0"/>, className: 'md:col-12 mb-0'},
      {type: 'custom', body: <label><b>Điều kiện</b><span className="required">*</span></label>, className: 'md:col-12 mb-0'},
      {type: 'custom', body: 'Số bản ghi log được lấy để tạo hóa đơn mỗi lần quét', className: 'md:col-5 pt-3'},
      {field: 'take', type: 'InputNumber', InputNumberProps: {min: 1, max: 2000}, className: 'md:col-4'},
      {type: 'custom', body: <Button icon="pi pi-plus" onClick={addCondition} className="p-button-rounded p-button-outlined"/>, className: 'md:col-3 text-right'},
      {type: 'custom', body: renderEditing(), className: 'md:col-12 mb-0'},
      {field: 'typeJob', header: 'Loại đồng bộ', required: true, type: 'Dropdown', DropdownProps: {options: typeJobs}, className: 'md:col-12'}
    ],
    defaultValue: {
      isUse: true
    },
    createItem: (item) => {
      if (validate(item)) {
        return Promise.reject();
      }
      const condition = [];
      for (const conditionElement of conditions) {
        const _condition = {...conditionElement};
        delete _condition._id;
        condition.push(_condition);
      }
      return Service.createTenantJob({...item, condition: JSON.stringify({take: item.take, condition})});
    },
    updateItem: (id, item) => {
      if (validate(item)) {
        return Promise.reject();
      }
      const condition = [];
      for (const conditionElement of conditions) {
        const _condition = {...conditionElement};
        delete _condition._id;
        condition.push(_condition);
      }
      return Service.updateTenantJob({...item, id, condition: JSON.stringify({take: item.take, condition})});
    },
    refreshLazyData
  });

  const validate = item => {
    if (!item.take || !conditions?.length) {
      ToastService.error('Bạn chưa nhập điều kiện quét dữ liệu');
      return true;
    } else {
      for (const condition of conditions) {
        if (!condition.propertyName || !condition.operation || !condition.value) {
          ToastService.error('Bạn chưa nhập điều kiện quét dữ liệu');
          return true;
        }
      }
    }
    return false;
  }

  const {renderToolbar} = useToolbar({
    dataKey,
    create: () => {
      setConditions([]);
      create({
        minuteNextStep: 10,
        take: 1000,
        typeJob: 'sync_invoice'
      });
      addCondition();
    },
    update: item => {
      Service.getTenantJob({id: item.id, maxResultCount: 5}).then(result => {
        const updatingItem = result.items[0];
        const condition = JSON.parse(updatingItem.condition);
        const _conditions = [];
        for (const conditionElement of condition.condition) {
          _conditions.push({...conditionElement, _id: `${_conditions.length}_${Date.now()}`})
        }
        setConditions(_conditions);

        update({...updatingItem, take: condition.take});
      });
    },
    clone: item => {
      Service.getTenantJob({id: item.id, maxResultCount: 5}).then(result => {
        const updatingItem = result.items[0];
        const condition = JSON.parse(updatingItem.condition);
        const _conditions = [];
        for (const conditionElement of condition.condition) {
          _conditions.push({...conditionElement, _id: `${_conditions.length}_${Date.now()}`})
        }
        setConditions(_conditions);

        clone({...updatingItem, take: condition.take});
      });
    },
    reloadLazyData,
    selectedItems,
    deleteItem: (id) => {
      return Service.deleteTenantJob(id);
    }
  });

  return (
    <Fragment>
      {renderToolbar()}
      {renderDataTable()}
      {renderDialogCrup()}
    </Fragment>
  );
};
